import fetcher from 'utils/fetcher';
import { API_USUARIOSPERFIL, TOKEN_API_URL } from 'variables';
import { ResponseFetcher } from 'utils/fetcher/types';
import {
  Token,
  Introspect,
  GetTokenRequest,
  GetIntrospectRequest,
  GetLoginRequest,
} from 'store/oauth/types';
import objectToURLSearchParams from 'utils/objectToURLSearchParams';

// ​https://api.int.sir.renfe.es/epe/catalogo-int/oauth-epe/oauth2/token
export const getTokenRequest = (
  requestBody: GetTokenRequest
): Promise<ResponseFetcher<Token>> =>
  fetcher({
    url: `${TOKEN_API_URL}token`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: objectToURLSearchParams(requestBody),
    },
  });

// ​https://api.int.sir.renfe.es/epe/catalogo-int/oauth-epe/oauth2/login
export const getLoginRequest = async (
  requestBody: GetLoginRequest
): Promise<ResponseFetcher<boolean>> =>
  fetcher({
    url: `${API_USUARIOSPERFIL}login`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
    },
  });

// https://api.int.sir.renfe.es/epe/catalogo-int/oauth-epe/oauth2/introspect
export const getIntrospectRequest = async (
  requestBody: GetIntrospectRequest
): Promise<ResponseFetcher<Introspect>> =>
  fetcher({
    url: `${TOKEN_API_URL}introspect`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: objectToURLSearchParams(requestBody),
    },
  });
